const tabs = [
  {
    id: 'long-term-stock',
    name: 'FBA長期在庫',
    title: 'FBA長期在庫'
  },
  {
    id: 'fba-product-sales',
    name: 'FBA納品推奨',
    title: 'FBA納品推奨'
  },
  {
    id: 'product-available',
    name: 'セルモンへの出品',
    title: 'セルモンへの出品'
  },
  {
    id: 'sales-expansion',
    name: '販売機会拡大',
    title: '販売機会拡大'
  },
  {
    id: 'settings',
    name: '設定',
    title: '設定'
  }
]

export default tabs



// WEBPACK FOOTER //
// ./src/common/salemon-agent-tabs.js